import { actions } from './constants'

const initialState = {}

const reducer = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case actions.OPEN_MENU:
      return {
        [meta.name]: payload.options,
      }

    case actions.CLOSE_MENU:
      return {
        [meta.name]: undefined,
      }

    default:
      return state
  }
}

export default reducer
